import { accountFetchGetMe } from '@actions/account/account-fetch-get-me';
import { accountHandleError } from '@actions/account/account-handle-error';
import { useTypedDispatch, useTypedSelector } from '@hooks/store';
import { Box, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { sidebarGetIsOpen } from '@selectors/sidebar';
import { accountSetMe } from '@slices/account';
import { sidebarToggleOpen } from '@slices/sidebar';
import { MainLayoutHeader } from '@widgets/layout/main-layout/main-layout-header';
import { MainLayoutSidebar } from '@widgets/layout/main-layout/main-layout-sidebar';
import { useCallback, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import {
  AppBarStyled,
  MainContentStyled,
  MainLayoutStyled,
  mainLayoutToolbarSX,
} from './styled';

export const MainLayout: React.FC = () => {
  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down('lg'));
  const dispatch = useTypedDispatch();
  const leftDrawerOpened = useTypedSelector(sidebarGetIsOpen);

  const handleLeftDrawerToggle = useCallback(() => {
    dispatch(sidebarToggleOpen({ isOpen: !leftDrawerOpened }));
  }, [dispatch, leftDrawerOpened]);

  const fetchGetMe = useCallback(async () => {
    try {
      await dispatch(accountFetchGetMe());
    } catch (error: unknown) {
      dispatch(accountHandleError({ error }));
      dispatch(
        accountSetMe({
          email: '',
          name: '',
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(sidebarToggleOpen({ isOpen: !matchDownMd }));
  }, [dispatch, matchDownMd]);

  useEffect(() => {
    fetchGetMe();
  }, [fetchGetMe]);

  return (
    <MainLayoutStyled>
      <CssBaseline />

      <AppBarStyled
        drawerOpened={leftDrawerOpened}
        enableColorOnDark
        position="static"
        color="inherit"
        elevation={0}
      >
        <Toolbar sx={mainLayoutToolbarSX}>
          <MainLayoutHeader handleLeftDrawerToggle={handleLeftDrawerToggle} />
        </Toolbar>
      </AppBarStyled>

      <Box display="flex">
        <MainLayoutSidebar
          drawerOpen={leftDrawerOpened}
          drawerToggle={handleLeftDrawerToggle}
        />

        <MainContentStyled
          theme={theme} //
          open={leftDrawerOpened}
        >
          <Outlet />
        </MainContentStyled>
      </Box>
    </MainLayoutStyled>
  );
};
